import { EventType } from '../types/firebase';

interface EventTypeInfo {
  value: EventType;
  label: string;
  description: string;
}

export const EVENT_TYPES: EventTypeInfo[] = [
  {
    value: 'protest',
    label: 'Protest',
    description: 'A public demonstration to express opposition or support',
  },
  {
    value: 'rally',
    label: 'Rally',
    description: 'A mass meeting to show support for a cause',
  },
  {
    value: 'workshop',
    label: 'Workshop',
    description: 'An educational or training session',
  },
  {
    value: 'townhall',
    label: 'Town Hall',
    description: 'A public meeting for community discussion',
  },
  {
    value: 'fundraiser',
    label: 'Fundraiser',
    description: 'An event to raise money for a cause',
  },
  {
    value: 'volunteer',
    label: 'Volunteer Event',
    description: 'An organized volunteer activity',
  },
  {
    value: 'petition',
    label: 'Petition Drive',
    description: 'Gathering signatures for a petition',
  },
  {
    value: 'march',
    label: 'March',
    description: 'An organized walk or procession for a cause',
  },
  {
    value: 'conference',
    label: 'Conference',
    description: 'A formal meeting for discussion or training',
  },
  {
    value: 'debate',
    label: 'Debate',
    description: 'A formal discussion of opposing viewpoints',
  },
  {
    value: 'training',
    label: 'Training',
    description: 'Educational or skill development session',
  },
  {
    value: 'meetup',
    label: 'Meetup',
    description: 'Casual gathering of like-minded people',
  },
  {
    value: 'awareness',
    label: 'Awareness Campaign',
    description: 'Event to raise public awareness',
  },
  {
    value: 'advocacy',
    label: 'Advocacy Event',
    description: 'Event to promote or defend a cause',
  },
  {
    value: 'other',
    label: 'Other',
    description: 'Other type of event',
  },
]; 